module.exports = __webpack_public_path__ + "img/UTS-Icon2_os.18b8d2ab.png";